import type { HtmlElementStyles } from '@kidslabs/mario-nextjs-react-ui-core';

export const cartCouponFormStyles = (): HtmlElementStyles => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    inputContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    input: {
        flex: 1,
        padding: '8px 12px',
        borderRadius: 4,
        border: '1px solid #ddd',
    },
    button: {
        padding: '8px 16px',
        borderRadius: 4,
        backgroundColor: '#21409A',
        color: '#fff',
    },
    errorText: {
        fontSize: 12,
        color: '#e53935',
    },
    contentCardLoading: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        opacity: 0.7,
    },
    primary: {
        backgroundColor: '#21409A',
        color: '#fff',
    },
});
